import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ErrorHandler,
} from "@angular/core";
import {
  MessengerService,
  MessengerListenerInterface,
} from "@app/services/messenger.service";
import { SupermodalComponent } from "@app/components/common/supermodal.component";

@Component({
  selector: "messenger",
  template: `<supermodal
    aspect="from-bottom width-100 {{ level }}"
    displayLoading="true"
    title="{{ message }}"
    #waitingSupermodal
  >
  </supermodal> `,
})
export class MessengerComponent implements MessengerListenerInterface {
  @ViewChild("waitingSupermodal") waitingSupermodal: SupermodalComponent;
  level: string;
  message: string;

  constructor(private messengerService: MessengerService) {
    this.messengerService.registerMessengerListener(this);
    console.log("constructor called");
  }

  displayMessage(level: string, message: string) {
    this.level = level;
    this.message = message;
    this.waitingSupermodal.open();
    setTimeout(() => {
      this.waitingSupermodal.close();
    }, 3000);
  }
}
